package com.appcreator.compose

actual fun Throwable.platformPrintout() {
    printStackTrace()
}